// this script was in the skin fraunhofer7
// in the tpl.footer.html


window.onload = function () {
  //TODO: make this blocks cleaner and more efficient
  // possibly just based on not-logged-in class (when there is no avatar in header)?

  const mailTo = document.querySelector("a[href^='mailto']");
  const questionSignIcons = [...document.querySelectorAll(".glyphicon-question-sign")];
  const searchIcons = [...document.querySelectorAll(".glyphicon-search")];
  const mainbar = document.querySelector(".il-maincontrols");

  if (document.URL.indexOf("login.php") >= 0) {
    document.getElementById("ilContentContainer").classList.add("loginSeite");

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

    mainbar.style.display = "none";

    if (mailTo) {
      mailTo.parentNode.style.display = "none";
    }

    if (questionSignIcons) {
      questionSignIcons.map(icon => {
        icon.parentNode.parentNode.remove();
      });
    }

    if (document.documentElement.lang === "en") {

      document.getElementById("loginWelcomeTitle").innerHTML = "Welcome to the Fraunhofer learning platform";
      document.getElementById("loginWelcomeContent").innerHTML = "Your digital learning space for continuing education with Fraunhofer";

    } else if (document.documentElement.lang === "es") {

      document.getElementById("loginWelcomeTitle").innerHTML = "Bienvenidos a la plataforma de aprendizaje";
      document.getElementById("loginWelcomeContent").innerHTML = "El espacio de aprendizaje digital continuado de Fraunhofer";

    }

  } else if (document.URL.indexOf("showLogout") >= 0) {

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

    mainbar.style.display = "none";

    if (mailTo) {
      mailTo.parentNode.style.display = "none";
    }

    if (document.documentElement.lang === "de"){

      if (questionSignIcons) {
        questionSignIcons.map(icon => {
          icon.parentNode.parentNode.remove();
        });
      }

    }
  } else if (document.URL.indexOf("ilpasswordassistancegui") >= 0) {

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

    mainbar.style.display = "none";

    if (mailTo) {
      mailTo.parentNode.style.display = "none";
    }

    if (document.documentElement.lang === "de"){

      if (questionSignIcons) {
        questionSignIcons.map(icon => {
          icon.parentNode.parentNode.remove();
        });
      }
    }

  } else if (document.URL.indexOf("showTermsOfService") >= 0) {

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

    mainbar.style.display = "none";

    if (document.documentElement.lang === "de"){
      if (questionSignIcons) {
        questionSignIcons.map(icon => {
          icon.parentNode.parentNode.remove();
        });
      }
    }

  } else if (document.URL.indexOf("ilImprintGUI") >= 0 || document.URL.indexOf("ilStartUpGUI") >= 0 || ((document.URL.indexOf("ilrepositorygui&reloadpublic=1") >= 0 || document.URL.indexOf("ilrepositorygui&cmdNode") >= 0 || document.URL.indexOf("goto.php?target=root_1") >= 0) & document.querySelector(".icon.dshs.small.outlined") == null)) {

    if (questionSignIcons) {
      questionSignIcons.map(icon => {
        icon.parentNode.parentNode.remove();
      });
    }

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

  }

  // if (document.documentElement.lang === "en") {
  //
  //   document.getElementById("privacyLink").innerHTML = "&nbsp;Privacy&nbsp;";
  //   document.getElementById("privacyLink").href = "https://ilias.fraunhofer.de/privacy.html";
  //   document.getElementById("termsOfServiceLink").innerHTML = "&nbsp;Terms Of Service&nbsp;";
  //   document.getElementById("termsOfServiceLink").href = "ilias.php?lang=en&cmd=showTermsOfService&cmdClass=ilstartupgui&baseClass=ilStartUpGUI";
  //
  // } else if (document.documentElement.lang === "es") {
  //
  //   document.getElementById("privacyLink").innerHTML = "&nbsp;Protección de datos&nbsp;";
  //   document.getElementById("privacyLink").href = "https://ilias.fraunhofer.de/proteccionDeDatos.html";
  //   document.getElementById("termsOfServiceLink").innerHTML = "&nbsp;Condiciones de uso&nbsp;";
  //   document.getElementById("termsOfServiceLink").href = "ilias.php?lang=es&cmd=showTermsOfService&cmdClass=ilstartupgui&baseClass=ilStartUpGUI";
  //
  // }

  // check if logged in by the presence of il-avatar
  const isLoggedIn = document.querySelector('.il-avatar');
  const mobileMetabar = document.querySelector('.il-metabar-slates');

  if (!isLoggedIn) {
    const helpDiv = document.querySelectorAll('.glyphicon-question-sign')[1];

    searchIcons && searchIcons.map(icon => {
      icon.parentNode.parentNode.remove();
    });

    if (helpDiv) {
      helpDiv.parentNode.parentNode.remove();
    }
  }
};
